import {
  Component, OnInit, Input, OnDestroy, OnChanges, Output, EventEmitter,
  ViewChild, ElementRef
} from '@angular/core';
import { UntypedFormGroup, UntypedFormArray, UntypedFormControl } from '@angular/forms';
import { HoldingsNames } from 'src/app/modules/acbcr/common/models/holdings.models';
import { Subject } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { ApplicationState } from 'src/app/modules/acbcr/common/state/app.state';
import { getAppHoldingsNames, getSelectedHolding } from 'src/app/modules/acbcr/common/state/reducers/holdings.reducers';
import { takeUntil } from 'rxjs/operators';
import { getCurrentRoute } from 'src/app/modules/acbcr/common/state/reducers/route.reducers';
import { AnimalsTableService } from 'src/app/modules/acbcr/common/services/animals-table.service';
import { AddNewHoldingData } from 'src/app/modules/acbcr/common/state/actions/holdings.actions';
import { HelperDataService } from 'src/app/modules/acbcr/common/services/helper-data.service';
import { convertDateToBackendFormat } from 'src/app/modules/acbcr/common/services/services-table-helper';
import { UIHelper } from 'src/app/modules/acbcr/components/common/helper/ui-helper';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-identificare-animal-form-block',
  templateUrl: './identificare-form-block.component.html',
})
export class IdentificareAnimalFormBlockComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild('corespundeStandardModal') corespundeStandardModal: ElementRef;

  @Input() animalForm: UntypedFormGroup;
  @Input() disabledFields = {};
  @Input() submitted: boolean;
  @Input() modalType: string;
  @Output() selectedParent = new EventEmitter();
  @Output() closeUpdateModal = new EventEmitter();
  @Output() updateFields = new EventEmitter();

  holdingsNames: HoldingsNames[];
  holdingsNameForOwners: HoldingsNames[];
  destroy$: Subject<boolean> = new Subject<boolean>();

  raseAnimal = [
    {
      "id": 1,
      "name": "Charolaise",
      "shortname": "CH"
    },
    {
      "id": 2,
      "name": "Limousine",
      "shortname": "LM"
    },
  ];

  matricoleAnimal = [];
  status: boolean;
  exploatationId: number;
  currentRoute: string;
  observatie: string;
  dateError = false;
  isSuperAdmin = false;

  searchingAnimals = [];
  openAddEditModal = false;
  holdingData: any;
  indexDeleteTestADN = null;
  openDelete = false;
  idDelete;
  corespundeStandard;

  constructor(
    private store: Store<ApplicationState>,
    private animalsTableService: AnimalsTableService,
    private helperDataService: HelperDataService,
    public modalService: NgbModal,
  ) { }


  ngOnInit(): void {
    this.isSuperAdmin = UIHelper.isSuperAdmin();

    this.store.pipe(select(getAppHoldingsNames))
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: HoldingsNames[]) => {
        this.holdingsNames = response;
        this.holdingsNameForOwners = response;
      });

    this.store.pipe(select(getCurrentRoute))
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: string) => {
        this.currentRoute = response;
      });

    if (this.currentRoute.includes('/animale-exploatatie') &&
        !(this.modalType === 'add-mother' || this.modalType === 'add-father')) {

      // Read from the store selected holding data
      // For add animals from a specific holding display only the current holding
      this.store.pipe(select(getSelectedHolding))
        .pipe(takeUntil(this.destroy$))
        .subscribe((response: any) => {
          this.exploatationId = response.id;
          this.holdingsNames.map(holding => {
            if (holding.id === this.exploatationId) {
              this.holdingsNames = [holding];
              setTimeout(() => {
                this.animalForm.controls.exploatatieid.setValue(holding.id);
              }, 0);
            }
          });
        });
    }

    if (this.animalForm.value.mamapurtatoarematricol) {
      this.matricoleAnimal = [{id: this.animalForm.value.mamapurtatoareid, numarmatricol: this.animalForm.value.mamapurtatoarematricol}];
    }
  }

  ngOnChanges() {
    this.corespundeStandard = this.animalForm.value.corespunde_standard;

    if (this.animalForm.value.status == 1) {
      this.status = true;
    } else {
      this.status = false;
    }
  }

  changeStatus(event) {
    switch (event) {
      case true:
        this.animalForm.controls.status.setValue(1);
        break;
      case false:
        this.animalForm.controls.status.setValue(-1);
        break;
    }
  }

  // Get forms controls state
  get f() { return this.animalForm.controls; }

  get raseFormArray(): UntypedFormArray {
    return this.animalForm.controls.rase as UntypedFormArray;
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.unsubscribe();
  }

  searchAnimal(event) {
    if (event.term.length < 4) {
      this.searchingAnimals = [];
      return;
    }

    let req_params = {
      numarmatricol: event.term,
      sex: this.animalForm.value.sex,
    };

    this.helperDataService.getAnimals(req_params)
      .subscribe((response: any) => {
        this.searchingAnimals = response?.result;

        if (this.searchingAnimals && this.searchingAnimals.length >= 1) {
          this.animalForm.controls.numarmatricol.reset();
          this.animalForm.controls.id.reset();
        }
      });
  }

  selectedAnimal(event) {
    this.selectedParent.emit(event);
  }

  searchMatricol(event, sex) {
    if (event.term.length >= 3 && this.matricoleAnimal.length === 0) {
      this.helperDataService
        .getAnimalInfo(event.term, sex)
        .subscribe((response: any) => {
          this.matricoleAnimal = response.result;
        });
    } else if (event.term.length < 3) {
      this.matricoleAnimal = [];
    }
  }

  clearMatricoleAnimal() {
    this.matricoleAnimal = [];
  }

  dataNasteriiChanged(event) {
    this.animalForm.controls.datanastere.setValue(event);
    this.compareDates(event, this.f.dataintrareinexploatatie.value);
    this.updateFields.emit();
  }

  dataIntrareExploatatieChanged(event) {
    this.animalForm.controls.dataintrareinexploatatie.setValue(event);
    this.compareDates(event, this.f.datanastere.value);
  }

  compareDates(selectedDate, birthDate) {
    if (Date.parse(convertDateToBackendFormat(selectedDate)) < Date.parse(convertDateToBackendFormat(birthDate))) {
      this.dateError = true;
      this.f.dataintrareinexploatatie.setErrors({incorrect: true});
    } else {
      this.dateError = false;
      this.f.dataintrareinexploatatie.setErrors(null);
    }
  }

  openAddHoldingModal() {
    this.openAddEditModal = true;
  }

  closeAddUpdateModal(event) {
    this.openAddEditModal = event;
  }

  updateHoldingsList(event) {
    this.store.dispatch(
      new AddNewHoldingData(
        { id: event.id, name: event.name }
      )
    );
  }

  get test_adn(): UntypedFormArray {
    return this.animalForm.get('test_adn') as UntypedFormArray;
  }

  get test_adn_files(): UntypedFormArray {
    return this.animalForm.get('test_adn_files') as UntypedFormArray;
  }

  adaugaTestADN() {
    let cz_disabled = false;
    if (this.test_adn.controls.length > 0) {
      let fg = this.test_adn.controls[0] as UntypedFormGroup;

      if (! this.isSuperAdmin) {
        cz_disabled = fg.controls.readonly.value;
      }
    }

    let testADNForm = new UntypedFormGroup({
      id: new UntypedFormControl(),
      metoda: new UntypedFormControl(),
      tip: new UntypedFormControl(),
      id_rg: new UntypedFormControl(),
      numar_adn: new UntypedFormControl(),
      afiseaza_in_cz: new UntypedFormControl({value: false, disabled: cz_disabled}),
      data_eliberarii: new UntypedFormControl(),
      readonly: new UntypedFormControl(false),
    });

    this.test_adn.push(testADNForm);
  }

  dataEliberariiChanged(event, testADNForm: UntypedFormGroup) {
    testADNForm.controls.data_eliberarii.setValue(event);
  }

  openDeleteModal(index) {
    this.openDelete = true;
    this.indexDeleteTestADN = index;
  }

  closeDeleteModal(event) {
    this.openDelete = false;

    if (event != true) {
      return;
    }

    this.test_adn.removeAt(this.indexDeleteTestADN);
  }


  uploadServerResponse(event) {
    const file = event.body.files[0];

    let testADNFileForm = new UntypedFormGroup({
      fileid: new UntypedFormControl(file.file_id),
      uploaded_file_name: new UntypedFormControl(file.file_uploaded_name),
    });
    this.test_adn_files.push(testADNFileForm);
  }

  downloadFisierTestADN(event, testADNFileForm: UntypedFormGroup) {
    event.target.disabled = true;
    let fileName = testADNFileForm.value.uploaded_file_name;
    let fileid = testADNFileForm.value.fileid;

    this.helperDataService.downloadFile(fileid).subscribe((response: any) => {
      const blob = new Blob([response]);
      this.helperDataService.simulateDownload(blob, fileName);
      event.target.disabled = false;

    });
  }

  deleteFisierTestADN(index) {
    this.test_adn_files.removeAt(index);
  }

  changeAfiseazaInCZ(testADNForm: UntypedFormGroup) {
    for (let i = 0; i < this.test_adn.controls.length; i++) {
      let arrayFormGroup = this.test_adn.controls[i] as UntypedFormGroup;

      if (arrayFormGroup == testADNForm) {
        arrayFormGroup.controls.afiseaza_in_cz.setValue(true);
      } else {
        arrayFormGroup.controls.afiseaza_in_cz.setValue(false);
      }
    }
  }

  clickCorespundeStandard() {
    this.modalService.open(this.corespundeStandardModal, {
      centered: true,
      scrollable: false,
      backdrop: 'static',
      keyboard: false,
    });
  }

  confirmareCorespundeStandard(confirmare?: boolean) {
    if (confirmare) {
      let req_params = {
        id: this.animalForm.value.id,
        observatie: this.observatie,
        corespunde_standard: this.animalForm.value.corespunde_standard,
      };

      this.animalsTableService.corespundeStandardAPI(req_params)
        .subscribe({
          next: (response) => {
            this.closeUpdateModal.emit();
          }
        });
    }
  }

  closeModalCorespundeStandard () {
    this.animalForm.controls.corespunde_standard.setValue(this.corespundeStandard);
  }

  selectareExploatatie(event) {
    let codExploatatie = event ? event['code'] : null;
    this.animalForm.controls.cod_exploatatie.setValue(codExploatatie);
  }

  selectareCrescator(event) {
    let codCrescator = event ? event['code'] : null;
    this.animalForm.controls.cod_crescator.setValue(codCrescator);
  }

  inputSelect(event) {
    let numarMatricol = event.target.value.toUpperCase();
    event.target.value = numarMatricol;
    this.animalForm.controls.numarmatricol.setValue(numarMatricol);
    this.updateFields.emit();
  }

  numarmatricolChange(event) {
    let numarMatricol = event.target.value.toUpperCase();
    this.animalForm.controls.numarmatricol.setValue(numarMatricol);
    this.updateFields.emit();
  }

  changeRasaAnimal() {
    this.updateFields.emit();
  }

  removeAnimalBreed(index) {
    this.raseFormArray.removeAt(index);
    this.changeRasaAnimal();
  }

}
